// extracted by mini-css-extract-plugin
export default {"wrapper":"edc_wrapper__0DLpo"};